import { apiUrl, upload } from './api';

/** Files a ticket can have that aren't pictures: PDFs, documents, spreadsheets, logs. */
export const MAX_TICKET_FILES = 10;
export const MAX_TICKET_FILE_BYTES = 25 * 1024 * 1024;

/** The kinds a ticket takes, as the file picker and the error wording use them (the server keeps the same list). */
export const TICKET_FILE_EXTENSIONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'odt', 'ods', 'odp', 'zip', 'rtf', 'csv', 'txt', 'log', 'eml'];
export const TICKET_FILE_ACCEPT = TICKET_FILE_EXTENSIONS.map((extension) => `.${extension}`).join(',');

export interface TicketFile {
  id: string;
  fileName: string;
  contentType: string;
  sizeBytes: number;
  uploadedByName: string;
  createdAt: string;
  /** Technicians remove any file; others the ones they added. */
  canDelete: boolean;
}

export const ticketFileUrl = (workOrderId: string, fileId: string) => apiUrl(`/work-orders/${workOrderId}/files/${fileId}`);

/** "2.4 MB", "38 KB" */
export const formatBytes = (bytes: number) => (bytes >= 1024 * 1024 ? `${(bytes / (1024 * 1024)).toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`);

export const ticketFileKind = (fileName: string) => TICKET_FILE_EXTENSIONS.includes((/\.([a-z0-9]{1,8})$/i.exec(fileName)?.[1] ?? '').toLowerCase());

/** Uploads a file to a ticket. Pictures belong in the ticket's pictures, so they're turned away here. */
export const uploadTicketFile = (workOrderId: string, file: File) =>
  upload<TicketFile>(`/work-orders/${workOrderId}/files`, file, { 'x-file': encodeURIComponent(JSON.stringify({ fileName: file.name.slice(0, 255) })) });
